import React, { PropsWithChildren, useEffect, useReducer, useState } from 'react';
import { defaultSocketContextState, SocketContextProvider, SocketReducer } from './SocketContext';
import { AppSocketContextHttpClient } from '../HttpClient/AppClient';
import { useSocket } from '../hooks/useSocket';

export interface ISocketContextComponentProps extends PropsWithChildren {}

const SocketContextComponent: React.FunctionComponent<ISocketContextComponentProps> = (props) => {
    const { children } = props;

    const socket = useSocket(process.env.REACT_APP_API_URL as string, {
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
        autoConnect: false,
        transports: ['websocket']
    });

    const [SocketState, SocketDispatch] = useReducer(SocketReducer, defaultSocketContextState);
    const [loading, setLoading] = useState(true);

    const getClient = () => {
        return new AppSocketContextHttpClient(socket.id as string);
    };

    useEffect(() => {
        socket.connect();
        SocketDispatch({ type: 'update_socket', payload: socket });
        StartListeners();
        SendHandshake();
        // eslint-disable-next-line
    }, []);

    const StartListeners = () => {
        /** Messages */
        socket.on('user_connected', (users: string[]) => {
            SocketDispatch({ type: 'update_users', payload: users });
        });

        /** Messages */
        socket.on('user_disconnected', (uid: string) => {
            SocketDispatch({ type: 'remove_user', payload: uid });
        });

        /** Connection / reconnection listeners */
        socket.io.on('reconnect', (attempt) => {
            SendHandshake();
        });

        socket.io.on('reconnect_attempt', (attempt) => {
        });

        socket.io.on('reconnect_error', (error) => {
        });
    };

    const SendHandshake = async () => {
        socket.emit('handshake', async (uid: string, users: string[]) => {
            SocketDispatch({ type: 'update_users', payload: users });
            SocketDispatch({ type: 'update_uid', payload: uid });
        });

        setLoading(false);
    };

    if (loading) return <p>... loading Socket IO ....</p>;

    return <SocketContextProvider value={{ SocketState, SocketDispatch, getClient }}>{children}</SocketContextProvider>;
};

export default SocketContextComponent;
